import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import React from 'react';
import { hasResolveEntitiesOrResolution } from 'app/components/ReusableUIComponents/HighLevelComponents/ResolveEntitiesModalMAIQ/utils';
import {
  extractSegmentNameFromSegmentRow,
  extractTemplateIdsFromSegmentRow,
  getSegmentAttentionReasonCode,
  HIL_SEGMENT_REASON_TEMPLATE_PENDING_APPROVAL,
  HIL_SEGMENTS_OPEN_RESOLVE_ACTIONS,
  HIL_SEGMENTS_RETRY,
} from 'app/utils/hilSegmentsAttentionUtils';

const RETRY_TOOLTIP = 'Retry';
const RESOLVE_TOOLTIP = 'Resolve';

interface CellHilSegmentsAttentionActionsProps {
  params: any;
  onClick: (params: any, clickedElement: string) => void;
}

const CellHilSegmentsAttentionActions = ({
  params,
  onClick,
}: CellHilSegmentsAttentionActionsProps) => {
  const reasonCode = getSegmentAttentionReasonCode(params?.row);
  const segmentName = extractSegmentNameFromSegmentRow(params?.row);
  const templateIds = extractTemplateIdsFromSegmentRow(params?.row);
  const isRetrying = Boolean(params?.row?.__retrying);
  const canRetry = Boolean(segmentName && reasonCode);
  const showResolve =
    hasResolveEntitiesOrResolution(params?.row) ||
    (reasonCode === HIL_SEGMENT_REASON_TEMPLATE_PENDING_APPROVAL &&
      templateIds.length > 0);

  if (!canRetry && !showResolve) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
      {canRetry ? (
        <Tooltip title={isRetrying ? 'Retrying...' : RETRY_TOOLTIP}>
          <span>
            <IconButton
              size="small"
              aria-label="retry segment attention resolve"
              disabled={isRetrying}
              onClick={e => {
                e.stopPropagation();
                onClick(params, HIL_SEGMENTS_RETRY);
              }}
              sx={{ padding: 0.5 }}
            >
              {isRetrying ? (
                <CircularProgress size={16} thickness={5} />
              ) : (
                <ReplayIcon fontSize="small" />
              )}
            </IconButton>
          </span>
        </Tooltip>
      ) : null}
      {showResolve ? (
        <Tooltip title={RESOLVE_TOOLTIP}>
          <IconButton
            size="small"
            aria-label="open resolve actions modal"
            onClick={e => {
              e.stopPropagation();
              onClick(params, HIL_SEGMENTS_OPEN_RESOLVE_ACTIONS);
            }}
            sx={{ padding: 0.5 }}
          >
            <TaskAltOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : null}
    </Box>
  );
};

export default CellHilSegmentsAttentionActions;
